module.exports = __webpack_public_path__ + "a0d918141f5ae9de50d25ddb7dbf6e91.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipes/Assets/frittatas.png
// module id = 1344
// module chunks = 0